import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/',
    component: () => import('../views/layout/index'),
    children: [
      {
        name: '/',
        path: '/',
        meta: { title: 'Início', isLogin: false },
        component: () => import('../views/Início/Início')
      },
      {
        name: 'vip',
        path: '/vip',
        meta: { title: 'vip', isLogin: true },
        component: () => import('../views/vip/vip')
      },
      {
        name: 'Indique',
        path: '/Indique',
        meta: { title: 'Indique', isLogin: true },
        component: () => import('../views/Indique/Indique')
      },
      {
        name: 'Perfil',
        path: '/Perfil',
        meta: { title: 'Perfil', isLogin: true },
        component: () => import('../views/Perfil/Perfil')
      },
      {
        name: 'PerfilConta',
        path: '/PerfilConta',
        meta: { title: 'PerfilConta', isLogin: true },
        component: () => import('../views/Perfil/Conta')
      },
      {
        name: 'PerfilHistory',
        path: '/PerfilHistory',
        meta: { title: 'PerfilHistory', isLogin: true },
        component: () => import('../views/Perfil/History')
      },
      {
        name: 'PerfilTransactio',
        path: '/PerfilTransactio',
        meta: { title: 'PerfilTransactio', isLogin: true },
        component: () => import('../views/Perfil/Transactio')
      },
      {
        name: 'Scratch',
        path: '/Scratch',
        meta: { title: 'Scratch', isLogin: false },
        component: () => import('../views/Scratch/Scratch')
      },

      {
        name: 'recharge',
        path: '/recharge',
        meta: { title: 'recharge', isLogin: false },
        component: () => import('../components/recharge')
      },
    ]
  },
  {
    name: 'login',
    path: '/login/:type',
    meta: { title: 'login', isLogin: false },
    component: () => import('../components/login')
  },
  {
    name: 'withdraw',
    path: '/withdraw/:type',
    meta: { title: 'withdraw', isLogin: false },
    component: () => import('../components/withdraw')
  },
  {
    name: 'Vip3Activity',
    path: '/activity/vip3',
    meta: { title: 'Vip3Activity', isLogin: true },
    component: () => import('../views/activity/Vip3')
  },
  {
    name: 'CaixaActivity',
    path: '/activity/caixa',
    meta: { title: 'CaixaActivity', isLogin: true },
    component: () => import('../views/activity/Caixa')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.isLogin && !store.state.userInfo.token) {
    router.push({path: '/login/login'})
  } else {
    next();
  }
});

let originPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, _ => {
    }, _ => {
    })
  }
}

export default router
